// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2khI1","left":"styles_left__1jTDb","desktopActions":"styles_desktopActions__RZdgb","title":"styles_title__j5-Oq"};